module.exports = __webpack_public_path__ + "img/Vision_02.233a4986.jpg";